import styled from 'styled-components'
import { StyledSelect } from 'components/forms'

export const Section = styled.div`
  margin-bottom: 1rem;
`

export const Row = styled.div`
  display: flex;
  gap: 1rem;
  > * { flex: 1; }
`

export const TypeaheadWrap = styled(StyledSelect)`
  ${({ theme: { colors } }) => `
    ${'' /* ensure the inner input blends */}
    &:focus-within { border-color: ${colors('text')}; }
  `}
`

export const TypeaheadInput = styled.input`
  ${({ theme: { colors, defaults, font } }) => `
    box-sizing: border-box;
    width: 100%;
    height: 2.75rem;
    padding: 0 ${defaults('padding')};
    background: transparent;
    border: none;
    outline: none;
    font-size: ${font('md')};
    color: ${colors('foreground')};
    &::placeholder { color: ${colors('neutral')}; }
  `}
`

export const FieldLabel = styled.label`
  ${({ theme: { colors, font } }) => `
    display: block;
    font-size: ${font('sm')};
    font-weight: 500;
    color: ${colors('neutral')};
    margin-bottom: 0.25rem;
  `}
`

export const FieldWrap = styled.div`
  margin: 0.5rem;
`
